// 1. Framework First (Module)
import '../framework/framework.js';
import API from '../framework/api.js';
import { API_RESOURCES } from './api_resources.js';

// 2. Application configuration
API.configureResources(API_RESOURCES);

// 3. Route registration (transitively imports all views/layouts/components)
import './app_routes.js';

console.log("CMS SPA Initialized");
